import { useClientAsyncInit, StatsigProvider } from '@statsig/react-bindings';
import Spinner from 'components/spinner/spinner.component';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectStatsigUser } from 'redux/user/user.selectors';

const StatsigWrapee = ({ sdkKey, options, children }) => {
  const user = useSelector(selectStatsigUser);

  const { client, isLoading } = useClientAsyncInit(sdkKey, user, options);

  useEffect(() => {
    if (!isLoading) client.updateUserAsync(user);
  }, [client, isLoading, user]);

  if (isLoading) return <Spinner />;

  return <StatsigProvider client={client}>{children}</StatsigProvider>;
};

export default StatsigWrapee;
